export default [
    {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home/HomeView.vue')
    }
]
